
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/guide-to-competitive-programming",
      function () {
        return require("private-next-pages/books/guide-to-competitive-programming.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/guide-to-competitive-programming"])
      });
    }
  